import dicePng from '/img/shop/v2/dice-icon.png';
import diceWebp from '/img/shop/v2/dice-icon.webp';
import offersPng from '/img/shop/v2/tabs/offers.png';
import offersWebp from '/img/shop/v2/tabs/offers.webp';
import packsPng from '/img/shop/v2/tabs/packs.png';
import packsWebp from '/img/shop/v2/tabs/packs.webp';
import promoPng from '/img/shop/v2/tabs/promo.png';
import promoWebp from '/img/shop/v2/tabs/promo.webp';
import vipPng from '/img/shop/v2/tabs/vip.png';
import vipWebp from '/img/shop/v2/tabs/vip.webp';
import tgemPng from '/img/shop/v2/tgem-icon.png';
import tgemWebp from '/img/shop/v2/tgem-icon.webp';

const SHOP_TABS = ['offers', 'tgem', 'vip', 'packs', 'dice', 'promo'] as const;

type ShopTabId = (typeof SHOP_TABS)[number];

interface ShopTabInfo {
  id: ShopTabId;
  label: string;
  png: string;
  webp: string;
  /** How much the art is scaled inside its 32px box (Figma crop) */
  scale: number;
}

const shopTabsInfo: ShopTabInfo[] = [
  {
    id: 'offers',
    label: 'Offers',
    png: offersPng,
    webp: offersWebp,
    scale: 1.0667,
  },
  { id: 'tgem', label: 'T-Gem', png: tgemPng, webp: tgemWebp, scale: 1 },
  { id: 'vip', label: 'VIP', png: vipPng, webp: vipWebp, scale: 1.2333 },
  {
    id: 'packs',
    label: 'Packs',
    png: packsPng,
    webp: packsWebp,
    scale: 1.0667,
  },
  { id: 'dice', label: 'Dice', png: dicePng, webp: diceWebp, scale: 1 },
  {
    id: 'promo',
    label: 'Promo',
    png: promoPng,
    webp: promoWebp,
    scale: 1.0667,
  },
];

// Old numeric tab ids still used by links into the shop
const legacyTabIds: Record<string, ShopTabId> = {
  '1': 'offers',
  '2': 'tgem',
  '3': 'promo',
};

const toShopTabId = (id?: string | null): ShopTabId => {
  if (!id) return 'offers';

  if (legacyTabIds[id]) return legacyTabIds[id];

  return (SHOP_TABS as readonly string[]).includes(id)
    ? (id as ShopTabId)
    : 'offers';
};

export { SHOP_TABS, type ShopTabId, shopTabsInfo, toShopTabId };
